import { z } from 'zod';
import { bankNameSchema } from './bank.schema';
import { paymentMethodsHyperPaySchema } from './payment-hyperpay.schema';

//* payment status
export const paymentStatusCommonSchema = z.enum(['paid', 'not_paid', 'partially_paid']);
export type PaymentStatusCommon = z.infer<typeof paymentStatusCommonSchema>;

//* payment method (Online)
export const paymentMethodsOnlineSchema = z.enum([
  ...paymentMethodsHyperPaySchema.options,
  'bank_transfer',
]);
export type PaymentMethodsOnline = z.infer<typeof paymentMethodsOnlineSchema>;

//* payment methods (ALL)
// this is Hero Wallet ... this mainly will be used when a customer pays in advance and start deducing from his wallet ... so the method is wallet.
const walletPayment = 'wallet';

export const paymentMethodsAllSchema = z.enum([
  ...paymentMethodsOnlineSchema.options,
  'cash',
  walletPayment,
]);
export type PaymentMethodsAll = z.infer<typeof paymentMethodsAllSchema>;

// * providers
// `hyperpay` is the freight network gateway. `moyasar` is the platform-sales
// gateway used by the `sales/` backend module for Hero subscriptions and
// addons. Both providers coexist; freight flows still use HyperPay.
export const onlinePaymentProviderSchema = z.enum(['hyperpay', 'moyasar']);
export type OnlinePaymentProvider = z.infer<typeof onlinePaymentProviderSchema>;

export const paymentProviderSchema = z.enum([
  ...bankNameSchema.options,
  ...onlinePaymentProviderSchema.options,
  // @TBC -- any bank ... we will make this by specific bank name.
  'bank',
  'cash',
  walletPayment,
]);
export type PaymentProvider = z.infer<typeof paymentProviderSchema>;

//* payment gateway
export const paymentGatewaySchema = z.object({
  method: paymentMethodsAllSchema,
  provider: paymentProviderSchema,
});

export type PaymentGateway = z.infer<typeof paymentGatewaySchema>;
